import React from "react";
import { Input } from "./Input";

export interface FormInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  type: "text" | "email" | "password" | "number";
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  label: string;
  isRequired: boolean;
  error: string | undefined;
  className: string;
  touched: boolean | undefined;
}

export default function FormInput({
  label,
  isRequired,
  className,
  error,
  touched,
  ...rest
}: FormInputProps): JSX.Element {
  return (
    <div className={"mb-4"}>
      <label
        style={{
          fontSize: "small",
          marginBottom: 4,
        }}
      >
        {label} <span className="text-danger">{isRequired ? "*" : ""}</span>
      </label>
      <Input {...rest} className="is-invalid" />
      <div className="text-danger fw-medium">
        {touched && error ? error : ""}
      </div>
    </div>
  );
}
